<template>
    <router-view :key="$route.path"></router-view>
</template>

<script>
    export default {
        name:'Booking',
        beforeRouteLeave(to, from, next) {
            if( 
                typeof to.meta.type == 'undefined' ||
                to.meta.type != 'booking'
            ) this.$store.commit('CLEAR_BOOKING_WRITE');
            next();
        },
        created () {
            this.$store.state.headerTitle = '컨설턴트 추천 매칭';
        },
    }
</script>

<style scoped>

</style>